// removed by extract-text-webpack-plugin
module.exports = {"durationWrapper":"_3n5fo_Ase0RDzggRvXVjxz","active":"_3nvN4HyKevARdif8hTRD44","inactive":"_6tq3bPINVtaW74Ctk8iuw","interval":"_1QIdB-0q4Jtcje5eqEVONm","button":"_3MzzzR1rrb-kLm52CO71wl"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/durationSlider/durationSlider.scss
// module id = 444
// module chunks = 0